import { z } from 'zod';
import { inferApiResultSchema } from './infer-api';

export const DemandAttachmentSchema = z.object({
  id: z.number(),
  demandId: z.number(),
  name: z.string(),
  attachmentUrl: z.string().max(2083),
  mimeType: z.string(),
  size: z.number(),
  createdAt: z.date(),
  userId: z.string().max(50).nullish(),
});
export type DemandAttachmentDto = z.infer<typeof DemandAttachmentSchema>;

export const GetDemandAttachmentResponseSchema = inferApiResultSchema(DemandAttachmentSchema);
export type GetDemandAttachmentResponseDto = z.infer<typeof GetDemandAttachmentResponseSchema>;

export const GetDemandAttachmentsResponseSchema = inferApiResultSchema(
  z.array(DemandAttachmentSchema),
);
export type GetDemandAttachmentsResponseDto = z.infer<typeof GetDemandAttachmentsResponseSchema>;

export const CreateDemandAttachmentSchema = DemandAttachmentSchema.omit({
  id: true,
  createdAt: true,
});
export type CreateDemandAttachmentDto = z.infer<typeof CreateDemandAttachmentSchema>;

export const CreateDemandAttachmentResponseSchema = inferApiResultSchema(DemandAttachmentSchema);
export type CreateDemandAttachmentResponseDto = z.infer<
  typeof CreateDemandAttachmentResponseSchema
>;
